<template>
  <div>
    <RouterView />
  </div>
</template>

<script>
import { packageItemMethods } from '@/store/adminHelper';

export default {
  name: 'PackageItemIdBase',
  props: {
    packageItemId: {
      type: String,
      required: true,
    },
  },
  created() {
    this.setCurrent(this.packageItemId);
  },
  beforeRouteUpdate(to, from, next) {
    const { packageItemId: packageItemIdTo } = to.params;
    const { packageItemId: packageItemIdFrom } = from.params;
    if (packageItemIdTo !== packageItemIdFrom) {
      this.setCurrent(packageItemIdTo);
    }
    next();
  },
  destroyed() {
    this.setCurrent(null);
  },
  methods: {
    ...packageItemMethods,
  },
};
</script>
